export default "__VITE_ASSET__CfBrrvSH__"